import React, { useState } from "react";
import cx from "classnames";
import { ArrowDown, ArrowUp } from "../../../assets/icons";
import NewTooltips from "../../../assets/icons/NewTooltips";
import { formatMoney, useGetPaymentCurrencyList } from "../../../utils";
import { useCompanyStore } from "../../../state/useCompanyStore";
import TooltipDropdown from "../../common/tooltipDropdown";

interface TrendStatsCardProps {
  title: string;
  titleIcon: any;
  value: string | number;
  percentageValue?: number;
  trendtitle?: string;
  isUptrend: boolean;
  isCashBalance?: boolean;
  toolTipText?: string;
  hide?: boolean;
  showArrow?: boolean;
}

const TrendStatsCard: React.FC<TrendStatsCardProps> = ({
  title,
  titleIcon,
  isUptrend,
  value,
  trendtitle,
  toolTipText,
  isCashBalance,
  percentageValue,
  hide = false,
  showArrow = false,
}) => {
  const companyProfile = useCompanyStore();
  const { userCurrencyCode } = useGetPaymentCurrencyList(
    companyProfile.company,
  );
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <div className="w-full h-full px-3 pt-3 pb-[10px] md:pb-[20px] bg-[#ffffff] border border-[#EAECF0] rounded-lg">
        <div className="text-[#344054] font-medium flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span>{titleIcon}</span>
            <p className="text-[14px] 1220:text-[13px] xl:text-[14px]  leading-5">
              {title}
            </p>
            {toolTipText && !hide && (
              <div
                className="relative"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {toolTipText && !hide && (
                  <div
                    className="relative"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <TooltipDropdown
                      toolTipText={toolTipText}
                      isHovered={isHovered}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          {trendtitle && (
            <p className="text-[14px] text-gray-400 leading-3">{trendtitle}</p>
          )}
        </div>

        <div className="flex items-center gap-2 mt-5">
          <p className="text-[20px] 1220:text-[16px] xl:text-[20px] text-[#000000] font-semibold leading-6">
            {Number(value) == 0
              ? "--"
              : isCashBalance
                ? formatMoney(Number(value), userCurrencyCode?.currency)
                : value}
          </p>
        </div>

        <div className="flex items-center gap-2 mt-3">
          <p className="text-[20px] 1220:text-[16px] xl:text-[20px] text-[#000000] font-semibold leading-6">
            {Number(value) !== 0 && showArrow && (
              <div
                className={` p-1 flex rounded-[4px] gap-1 items-center ${
                  isUptrend ? "bg-uptrend" : "bg-downtrend"
                }`}
              >
                {isUptrend ? <ArrowUp /> : <ArrowDown />}
                <h1
                  className={`text-[14px] font-semibold 1220:text-[16px] xl:text-[16px] pr-2 ${isUptrend ? "text-[#37C89A]" : "text-[#D82020]"}`}
                >
                  {percentageValue}%
                </h1>
              </div>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export { TrendStatsCard };
